var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSearch02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M.467 9.088a8.621 8.621 0 1 1 17.242 0 8.621 8.621 0 0 1-17.242 0M9.087 2.2a6.888 6.888 0 1 0 0 13.775 6.888 6.888 0 0 0 0-13.775",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m19.138 20.363-4.847-4.847 1.226-1.225 4.846 4.846z",
  clipRule: "evenodd"
})));
export default SvgIconSearch02;